/**
 * @generated SignedSource<<a8648b81a2eeb68331b747b6ba0ee314>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ArchivedPageBannerV2Status_content$data = {
  readonly id: string | null;
  readonly status: string | null;
  readonly " $fragmentType": "ArchivedPageBannerV2Status_content";
};
export type ArchivedPageBannerV2Status_content$key = {
  readonly " $data"?: ArchivedPageBannerV2Status_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ArchivedPageBannerV2Status_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "Content"
};

(node as any).hash = "796cb3cff58c88eeb0ad9572d8c6b4df";

export default node;
